module.exports = __webpack_public_path__ + "img/setup.d53f460d.svg";